"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appointment = _interopRequireDefault(require("../../components/softBusinessLogistics/appointment.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _topNav = _interopRequireDefault(require("../../components/top-nav.vue"));
var _default = exports.default = {
  components: {
    appointment: _appointment.default,
    footNav: _footNav.default,
    topNav: _topNav.default
  },
  data: function data() {
    return {
      navItems: ['商务解决方案', '保险服务', '保费通', '轨迹定位', '城市合伙人', '企业宣传', 'AEBS', '仓储联盟'],
      currentSection: 0,
      isManualScrolling: false,
      // 增加一个“手动跳转中”的锁，防止点击导航时乱跳
      // 新增：记录当前选中的功能模块索引
      activeFeature: 0,
      featureList: [{
        name: '车源广场',
        // 灰色图标例子
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%BD%A6%E6%BA%90%E5%B9%BF%E5%9C%BAblue.svg',
        // 蓝色图标例子
        activeIcon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%BD%A6%E6%BA%90%E5%B9%BF%E5%9C%BA%23fff.svg',
        // 底部展示大图：卡车运输场景
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%BD%A6%E6%BA%90%E5%B9%BF%E5%9C%BA.png'
      }, {
        name: '货源大厅',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%B4%A7%E6%BA%90%E5%A4%A7%E5%8E%85blue.svg',
        activeIcon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%B4%A7%E6%BA%90%E5%A4%A7%E5%8E%85%23fff.svg',
        // 底部展示大图：仓库货源场景
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%B4%A7%E6%BA%90%E5%A4%A7%E5%8E%85.png'
      }, {
        name: '危化导航',
        icon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E5%8D%B1%E5%8C%96%E5%AF%BC%E8%88%AAblue.svg',
        activeIcon: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E5%8D%B1%E5%8C%96%E5%AF%BC%E8%88%AA%23fff.svg',
        // 底部展示大图：地图导航场景
        image: 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E5%8D%B1%E5%8C%96%E5%AF%BC%E8%88%AA.png'
      }],
      currentCaseIndex: 0,
      caseImages: ['https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E5%AE%9A%E5%88%B6%E5%8C%96%E6%96%B9%E6%A1%88.png', 'https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E7%89%A9%E6%B5%81%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E8%BF%90%E5%8A%9B%E5%9C%B0%E5%9B%BE.png']
    };
  },
  methods: {
    // 下一个
    nextFeature: function nextFeature() {
      if (this.activeFeature < this.featureList.length - 1) {
        this.activeFeature++;
      } else {
        this.activeFeature = 0; // 循环回到第一个
      }
    },
    // 上一个
    prevFeature: function prevFeature() {
      if (this.activeFeature > 0) {
        this.activeFeature--;
      } else {
        this.activeFeature = this.featureList.length - 1; // 循环到最后一个
      }
    },
    //合同物流
    prevCase: function prevCase() {
      if (this.currentCaseIndex > 0) {
        this.currentCaseIndex--;
      } else {
        this.currentCaseIndex = this.caseImages.length - 1;
      }
    },
    nextCase: function nextCase() {
      if (this.currentCaseIndex < this.caseImages.length - 1) {
        this.currentCaseIndex++;
      } else {
        this.currentCaseIndex = 0;
      }
    },
    // 滚动监听
    handleScroll: function handleScroll(e) {
      // 如果正在执行点击跳转的平滑滚动，直接拦截，不执行逻辑
      if (this.isManualScrolling) return;
      var target = e.target;
      var scrollTop = target.scrollTop;
      var clientHeight = target.clientHeight;
      var scrollHeight = target.scrollHeight;

      // 核心计算：总共能滚动的最大距离
      var maxScroll = scrollHeight - clientHeight;

      // 如果内容还没到需要滚动的程度，直接返回
      if (maxScroll <= 0) return;

      // 计算当前滚动的百分比 (0 - 100)
      var progress = scrollTop / maxScroll * 100;
      var activeIndex = 0;
      console.log(progress, "progressprogress");
      if (progress >= 93) {
        activeIndex = 7;
      } else if (progress >= 87) {
        activeIndex = 6;
      } else if (progress >= 75) {
        activeIndex = 5;
      } else if (progress >= 40) {
        activeIndex = 4;
      } else if (progress >= 30) {
        activeIndex = 3;
      } else if (progress >= 15) {
        activeIndex = 2;
      } else if (progress >= 5) {
        activeIndex = 1;
      } else {
        activeIndex = 0;
      }

      // 只有索引变动时才更新视图，性能最优
      if (this.currentSection !== activeIndex) {
        console.log("\u5F53\u524D\u8FDB\u5EA6\uFF1A".concat(progress.toFixed(2), "%\uFF0C\u5207\u6362\u5230\u7D22\u5F15\uFF1A").concat(activeIndex));
        this.currentSection = activeIndex;
      }
    },
    // 点击导航平滑跳转
    scrollToSection: function scrollToSection(index) {
      var _this = this;
      var sections = document.querySelectorAll('.section');
      if (sections[index]) {
        // 1. 开启防跳锁
        this.isManualScrolling = true;
        this.currentSection = index;

        // 2. 执行平滑滚动
        sections[index].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // 3. 延迟 800 毫秒（等待滚动动画结束）后再解开锁
        setTimeout(function () {
          _this.isManualScrolling = false;
        }, 800);
      }
    }
  }
};